import styled, { css } from 'styled-components';
import { animation } from 'utils';

export const LayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;

  ${({ $isFaqPage }) =>
    $isFaqPage &&
    css`
      height: 100vh;
      overflow: hidden;
    `}
`;

export const ContentWrapper = styled.div`
  flex-grow: 1;

  ${({ $isFaqPage }) =>
    $isFaqPage &&
    css`
      display: flex;
      flex-direction: column;
      overflow-y: auto;
    `}
`;

export const PageWrapper = styled.div`
  animation: ${animation.fadeInFromBottom} 0.4s ease-out;

  ${({ $isFaqPage }) =>
    $isFaqPage &&
    css`
      flex-grow: 1;
      display: flex;
      flex-direction: column;
    `}
`;

export const HeaderContainer = styled.div`
  position: sticky;
  top: 0;
  z-index: 10;
`;
